/* eslint-disable max-len, no-useless-escape */
const translationMap = {
  about: 'About & Help',
  about_blurb_p1: 'Since its inception in 2014, Resy has created best-in-class software that powers dining experiences and connects restaurants to a network of engaged diners. Diners rely on Resy for intel and access to the most exciting restaurants, from neighborhood favorites to cult classics, just-opened hot spots, and everything in between.',
  about_blurb_p2: 'For Diners: Resy is a consumer-facing reservation platform that powers dining across the globe. A destination for restaurant discovery, original content, and chef-driven culinary events, Resy is an essential resource for passionate diners. Explore the amazing world of restaurants in the Resy iOS app and at Resy.com.',
  about_blurb_p3: 'For Businesses: Resy’s restaurant partners use Resy OS to run their businesses smarter and more efficiently. Resy OS takes into account pre, during and post service guest touchpoints to help operators deliver the best hospitality experience. Platform features include table management, wait list functionality, customized SMS text confirmations, guest feedback tools, reports and analytics, ticketing, and more. With the powerful backing of American Express, Resy’s hospitality-driven support team is committed to helping businesses thrive.',
  about_content_1: 'At Resy, we’re the kind of people who habitually hunt down the best restaurants long before the rest of the world discovers them. We know the places that don’t look like much from the outside can be the best spots in town.',
  about_content_2: 'In 2014, we started to imagine what it would look like if restaurants had a true partner in technology — to help them improve their bottom line, streamline their operations, and deliver world-class hospitality for their guests. In 2019, Resy was acquired by American Express, and today, we continue to be driven by our mission: to connect the world’s best restaurants with the world’s best customers.',
  about_resy: 'About & Help',
  about_resy_link: 'About Resy &rsaquo;',
  accept_and_close: 'Accept & Close',
  accessibility_statement: 'Accessibility Statement',
  accessibility_statement_p1: 'Resy is committed to providing a valuable and more accessible digital experience for all visitors, including people with disabilities. We are continually improving our user experience for everyone and work to conform the accessibility of our website and our mobile applications with applicable law and to the <a href="https://www.w3.org/TR/WCAG21/" target="_blank" rel="noopener noreferrer">Web Content Accessibility Guidelines (v 2.1, level AA)</a> as recommended by the World Wide Web Consortium (W3C). Resy has verified the usability of its product in Windows + Jaws, MacOS + Voiceover and iOS + Voiceover.',
  accessibility_statement_p2: 'Encountering issues? Feedback? <a href="mailto:accessibility@resy.com">Click here</a>.',
  account: 'Account',
  add: 'Add',
  add_card: 'Add Card',
  advertisement: 'ADVERTISEMENT',
  location: 'Location',
  add_card_error_generic: 'Sorry. There was a problem with your card. Please double check all fields.',
  captcha_required: 'Please complete the CAPTCHA before submitting.',
  add_card_error_validation: 'Sorry. We could not validate your card. Please double check all fields.',
  add_credit_card: 'Add Credit Card',
  add_note: 'Add an optional note on allergies and restrictions...',
  add_photo_cta: 'Add Photo',
  add_to_hit_list: 'Add to Hit List',
  affiliated_restaurants: 'Affiliated Restaurants',
  algorithmic_lists_description: 'Algorithmic lists: climbing, top rated, and new on Resy',
  all_day: 'All Day',
  all_times: 'All Times',
  all_times_for_service: 'All times for {serviceTypeName}',
  all_restaurants: 'all restaurants',
  allergies: 'Allergies',
  restrictions: 'Restrictions',
  allergies_and_restrictions: 'Allergies and Restrictions',
  allergies_placeholder: 'Add a note on allergies and restrictions…',
  allergies_footnote: 'Resy shares provided allergy information with your restaurants to improve your dining experience.',
  allergies_note: 'Let the restaurant know in advance of any allergies or dietary restrictions.',
  allergy_note_disclosure_guest: 'We will share allergies, diet restrictions, or preferences you provide with our restaurants.',
  already_resy: 'Already have a Resy account?',
  and: 'and',
  apply_filter_resy_credit: 'Apply filter: Resy Credit',
  apply_here_link: 'Apply Here',
  at: 'at',
  at_home: 'At Home',
  back: 'Back',
  best_restaurants: 'The Best Restaurants are on Resy',
  birthday: 'Birthday',
  birthday_note: 'Let restaurants know when you’re celebrating.',
  blog: 'Blog',
  blog_hero_label: 'About Resy, statistics, and social media links',
  book_for: 'Book for',
  book_on: 'Book on',
  book_on_tock: 'Book on Tock',
  tock_interstitial_subheader: 'Tock is now part of the Resy Network',
  tock_interstitial_header: 'Finish booking on Tock',
  tock_interstitial_description: 'This reservation is managed by Tock. You’ll be redirected to Tock to complete your booking.',
  tock_interstitial_preference_hide: 'Don’t show this again',
  tock_interstitial_confirm_cta: 'Continue to Book on Tock',
  tock_interstitial_content_label: 'Tock booking interstitial',
  tock_reservations_notice_headline: 'Missing a Reservation?',
  tock_reservations_notice_body: 'If you booked through Tock, your reservation won\'t appear here. Check your confirmation email or manage your reservation directly on Tock.',
  tock_reservations_notice_link: 'Go to ExploreTock.com',
  tock_reservations_notice_badge: 'Now part of the Resy Network',
  offering_modal_close_label: 'Close Offering Modal',
  offering_modal_back_label: 'Back to options',
  offering_modal_content_label: 'Offering details: {experienceName}',
  offering_modal_default_venue_name: 'Venue',
  offering_modal_default_experience_name: 'Experience',
  tock_experience_options_title: 'Choose a {time} Option',
  tock_experience_options_party_label: 'Party of {seats}, {date}, {time}',
  tock_experience_options_more_times_label: 'More times for {name}',
  book: 'Book',
  more_times: 'More Times',
  book_now: 'book now',
  book_spots_like_venue: 'Book spots like {venueName}',
  book_tomorrow: 'Book Tomorrow',
  book_tonight: 'Book Tonight',
  button_add_notify: 'Notify',
  button_add_notify_venue_name: '{venueName}, Notify',
  button_copied_bang: 'Copied!',
  button_invite_confirm: 'I’ll be there',
  button_invite_decline: 'Not going',
  button_link_request: 'Get link',
  button_place_notify: 'Notify',
  button_remove_notify: 'Notify On',
  button_remove_notify_venue_name: '{venueName}, Notify On',
  button_submit: 'Submit',
  by: 'by',
  by_author: 'By {author}',
  calendar_icon: 'Calendar icon',
  calendar_legend_available: 'Available',
  calendar_legend_closed: 'Closed',
  calendar_legend_sold_out: 'Sold Out',
  calendar_legend_unavailable: 'Unavailable',
  card_verification_hold_message: 'To verify your card, our payment processor may place a temporary charge on your account, which will be released back to you within a few days.',
  careers_content_1: 'Interested in joining our team of restaurant lovers? Right this way.',
  careers_subcontent_1: 'Resy and American Express backs colleagues with the support they need professionally and personally. We offer a flexible working model, and roles vary between onsite, hybrid, and completely virtual. We offer the perks of a tech company (restaurant and health & wellness perks, team meals, events) with the stability and backing of American Express.',
  check_later: 'Check back later, or try another location.',
  checkout: 'Checkout',
  clear_search: 'Clear Search',
  click_here_for_info: 'Click here for more information about {product}',
  click_set_cookie_prefs: 'Change Cookie Preferences',
  climbing: 'climbing',
  climbing_desc: 'You dine, the restaurant climbs. Climbing on Resy is the only data-driven list powered by your reservations. Consider it a curated guide by locals, for locals.',
  close: 'Close',
  close_menu: 'Close menu',
  close_payment: 'Close payment',
  close_notify_modal: 'Close Notify Modal',
  close_profile_menu: 'Close profile menu',
  code_input_error: 'Oops, that didn’t work. Please enter the code that was sent to you.',
  otp_digit_number: 'Digit number {digitNumber} in OTP code',
  communication_error_message: 'Error.',
  communication_heading: 'Manage Your Communication Preferences',
  communication_heading_cities: 'Stay in the Restaurant Know',
  communication_heading_marketing: 'Sign Up for Resy Marketing Emails',
  communication_heading_primary: 'Select Your Primary Dining City',
  communication_loading_message: 'Loading...',
  communication_marketing_label: 'Get curated recommendations for where to dine, including The Resy Hit List, New on Resy, chef interviews, and more.',
  communication_other_section_title: 'Other Communications',
  communication_receive_rating_emails: 'Receive post-dining emails to provide feedback to restaurants.',
  communication_save: 'Save',
  communication_subheading: 'Opt in or out of email communications at any time. Resy only shares your information with restaurants you book, with your permission.',
  communication_subheading_primary: 'Setting a primary dining city ensures we show you nearby restaurants and tailor suggestions to your city.',
  communication_title: 'Communication',
  company_name_input: 'Company name...',
  company_name_input_label: 'Company Name',
  complementary_links: 'Complementary Links',
  concierge_pending: 'Thanks! Our team will review your request and respond within 2 business days.',
  concierge_registered: 'You are registered as a concierge.',
  concierge_registration_intro: 'If you frequently book reservations on behalf of others, you can join our concierge program.',
  concierge_registration_title: 'Concierge Registration',
  concierge_reservations: 'Concierge Reservations',
  country: 'Country',
  password_confirm: 'Confirm Password',
  confirmation_received: 'Confirmation received',
  contact: 'Contact',
  contact_amex_to_book: 'Contact Amex to Book',
  cookie_policy: 'Cookie Policy',
  copy_preview_link: 'Copy Preview Link',
  blog_nav_fallback_header: 'Discover restaurants to love.',
  blog_nav_homepage_cta: 'Read more &rsaquo;',
  blog_nav_blurb: 'Be the first to know with Resy’s insider guides, deep dives on old standbys, and vital intel on all the latest and greatest new openings.',
  create_an_account: 'Create an account',
  come_join_us: 'Come Join Us!',
  data_processing_addendum: 'Data Processing Addendum',
  date_picker: 'Date Picker',
  day: 'Day',
  default: 'Default',
  directions_link: 'Get Directions',
  discover_venue: 'Discover {venueName} &amp; More',
  download_app_body: 'Resy gives you access to a curated selection of the best restaurants in your city and beyond.',
  download_app_google: 'Download the Resy app from the Google Play store',
  download_app_itunes: 'Download the Resy app from the iTunes app store',
  download_our_app: 'Download our app',
  download_app_notify_message: 'Install the Resy app to receive Notify alerts and book reservations.',
  email: 'Email',
  email_address: 'Email Address',
  email_confirmed: 'Email Confirmed',
  empty_hit_list: 'There is nothing on your Hit List.',
  errors: {
    birthday: {
      incomplete: 'Please enter a complete birthday',
      invalid: 'Please enter a valid birthday',
    },
    email: 'Please enter a valid email address',
    first_name: 'Please include a valid first name',
    last_name: 'Please include a valid last name',
    parse: {
      captcha: 'Please complete the captcha so we know you are not a robot.',
      inactive: 'Your account is no longer active. Please sign up for a new account.',
      invalid: 'It looks like this password reset attempt has expired. Please try again.',
      login: "We couldn't validate your login information. Please check that your email and password are correct.",
      password: "The passwords you entered don't match. Please try again.",
      refresh: 'Error. Please refresh and try again.',
      try_again: 'Error. Please try again.',
    },
    phone_number: 'Please enter a valid phone number.',
    required: 'Please complete the required fields',
  },
  event: 'Event',
  events_description: 'placeholder',
  expand_nearby: 'Expand Nearby',
  failed: 'Failed',
  faq_question_4_5: 'What does “Notify” mean on Resy? Does it reserve a table for me?',
  faq_answer_4_5: 'No–setting a “Notify” is not a reservation. “Notify” lets you be alerted if a table you are looking to book becomes available. If a reservation matching your request (restaurant, date, time, party size) becomes available, you receive a notification. Reservations are only confirmed after you complete a booking and receive a confirmation email.',
  faq_question_8_3: 'We have introduced Tock venues on Resy.',
  faq_answer_8_3: 'Some restaurants, wineries, and experiences listed on Resy use the Tock platform to manage their reservations and ticketed experiences. For support related to a Tock booking, please visit <a href="https://www.exploretock.com/help">ExploreTock.com/help</a>.',
  faq_question_8_5: 'What if I can’t find my reservation details in my Resy account?',
  faq_answer_8_5: 'Some venues are discoverable on Resy, but reservations for those venues are completed and managed through Tock. If you booked one of these reservations through Resy and don’t see it in your Resy account, sign into your Tock account at <a href="https://www.exploretock.com">ExploreTock.com</a> or use the link in your reservation confirmation email to view or manage your booking.',
  faq_question_8_7: 'Why was I redirected from Resy to Tock to complete my booking?',
  faq_answer_8_7: 'Some venues available on Resy use Tock to manage reservations and ticketed experiences. When booking one of these venues, you will be redirected to Tock to complete your reservation. Before you are redirected, a message will let you know that you are leaving Resy and being taken to Tock to finish your booking.',
  faq_question_11_3: 'Will my guest preferences be applied to any bookings made on Tock?',
  faq_answer_11_3: 'You can search Tock venues on <a href="https://resy.com/">Resy.com</a> and the Resy app, but your profile preferences will not be applied to bookings made on Tock. You can edit your Tock profile at <a href="https://www.exploretock.com/profile">ExploreTock.com/profile</a>.',
  faq_question_11_5: 'Will my Resy account automatically connect to my Tock account?',
  faq_answer_11_5: 'No. At this time, your Resy account will not automatically connect to your Tock account. Resy and Tock reservations will continue to be managed separately. To cancel or modify a Tock reservation, sign in to your Tock account or use the link in your confirmation email.',
  faq_question_11_7: 'How will I know if I’m booking a Tock venue?',
  faq_answer_11_7: 'If a venue uses Tock to manage reservations or ticketed experiences, you will see a <i>Book on Tock</i> label when browsing venues in Resy. Selecting it will redirect you to complete your reservation on ExploreTock.com, and you will receive a confirmation email from Tock. ',
  faq_answer_13_1: '<a href="/resycredit">The Resy Credit</a> is an embedded card benefit for eligible American Express Cards. Enrolled Card Members can earn statement credits for eligible purchases made with their eligible card at qualifying U.S. restaurants. Qualifying restaurants and other food and beverage establishments must be located in the U.S. and will be indicated as eligible on their booking page at the time of purchase on <a href="https://resy.com/">Resy.com</a>, the Resy app, <a href="https://www.exploretock.com">ExploreTock.com</a>, or the Tock app. Terms apply.<br /><br />We recommend visiting <a href="https://americanexpress.com">AmericanExpress.com</a> or calling the number on the back of your Card for more information.',
  faq_question_13_3: 'What is Tock?',
  faq_answer_13_3: 'Tock is a reservation, table, and event management technology provider used by restaurants, wineries, and other venues. Tock was acquired by American Express in 2024.',
  faq_question_13_5: 'Why are Tock venues appearing on Resy?',
  faq_answer_13_5: 'Resy is expanding discovery for diners by introducing venues that use Tock for reservations and experiences. While you can discover these venues on Resy, booking and reservation management for participating venues takes place on Tock.',
  faq_about_tock_heading: 'About Tock, Resy’s sister reservation platform',
  faq_answer_16_1: 'Global Dining Access by Resy gives you special access to sought-after U.S. Resy restaurants when you add your eligible American Express Card to your Resy profile. Global Dining Access by Resy provides eligible American Express Card Members with access to exclusive reservations, Priority Notify, and a badge on your Resy profile, letting restaurants know that you are a valued member of the Global Dining Access program. Visit <a href="https://resy.com/globaldiningaccess">Resy.com/globaldiningaccess</a> or the Resy app and add your eligible American Express Card to your Resy profile to begin unlocking your benefits.',
  faq_question_16_3: 'Are Tock venues part of Global Dining Access?',
  faq_answer_16_3: 'Tock venues are not currently part of Global Dining Access by Resy and are not eligible for Priority Notify. We continue to evaluate opportunities to expand eligibility in the future. If there are any changes, we’ll share updates.',
  faq_question_16_7: 'Are there tables held at Tock venues nightly for Amex Card Members?',
  faq_answer_16_7: 'There are currently no nightly tables held for Card Members at Tock venues. We continue to evaluate opportunities to expand Global Dining Access benefits in the future. If there are any changes, we’ll share updates.',
  favorites_optin_content: 'Sign up for Resy marketing emails to receive curated recommendations and insider tips on top restaurants in your area. You agree to the use of your data as described in our <a href=\"/privacy\" target=\"_blank\">Privacy Policy</a>. You may opt out of receiving marketing emails at any time.',
  favorites_optin_header: 'Sign Up for Resy Email',
  favorites_optin_label: 'Sign Up for Email',
  favorites_optin_title: 'Monthly Hit Lists, Straight to Your Inbox',
  feedback_is_important: 'As a valued guest, your feedback is important to us and helps restaurants continue to improve.',
  feedback_form_header: 'Additional questions?',
  feedback_form: ' Please contact us by completing <a href="https://www.surveymonkey.com/r/JNQ7TLK?ID=%5BID_value%5D&Contact_ID_c=%5BContact_ID_c_value%5D&Account_ID=%5BAccount_ID_value%5D&Contact_ID=%5BContact_ID_value%5D" target="_blank">this form.</a>',
  fewer_collections: 'Fewer collections',
  first_name: 'First Name',
  follow_list: 'Follow List',
  follow_resy: 'Follow @Resy',
  footer: {
    about: 'About',
    careers: 'Careers',
    newsroom: 'Newsroom',
    ios_app: 'iOS App',
    android_app: 'Android App',
    head_1: 'Discover &amp; Book',
    head_2: 'For Businesses',
    nearby: 'Nearby Restaurants',
    climbing: 'Climbing',
    top_rated: 'Top Rated',
    new_on_resy: 'New on Resy',
    events: 'Events',
    stories: 'Stories',
    guides: 'Guides',
    hit_list: 'The Hit List',
    amex_offers: 'U.S. Card Offers from Amex',
    resy_os_overview: 'Resy OS Overview',
    features: 'Features',
    resy_os_blog: 'Resy OS Blog',
    resy_help: 'Resy Help Desk',
    resy_os_dashboard: 'Resy OS Dashboard',
    book_a_consultation: 'Book a Demo',
    resy_for_restaurants: 'Resy for Businesses',
    pricing: 'Pricing',
  },
  for: 'For',
  for_restaurants: 'For Businesses',
  forgot_password: 'Forgot password?',
  from_price: 'From {price}',
  gda_banner_text: 'Unlock Global Dining Access with an eligible American Express®️ Card',
  gda_eyebrow: 'Resy Global Dining Access',
  gda_description: 'We reserve tables exclusively for eligible American Express<sup>®</sup> Card Members.',
  gda_description_learn_more: 'Learn more',
  gda_icon: 'Global Dining Access icon',
  gda_search_description: 'These restaurants hold reservations exclusively for eligible American Express<sup>®</sup> Card Members.',
  gda_search_title: 'Resy’s Sought-After Restaurants',
  gda_title: 'Unlock Exclusive Tables with American Express',
  generic_error: 'There was a problem. Please try again.',
  generic_gating_header: 'Something went wrong',
  generic_gating_text: 'Please check your connection and try again. If you are still experiencing issues, please reach out to our customer support team at&nbsp;',
  generic_submission_error: 'There was a problem processing your request. Please try again.',
  get_notified_if_tickets_become_available: 'Get notified if tickets become available.',
  go_back: 'Go back',
  go_to_resy: 'Go to Resy.com ›',
  google: 'Google Calendar',
  guests: 'Guests',
  health_safety_description: 'This restaurant has committed to taking certain safety measures to provide a safe, comfortable dining experience.',
  help_and_feedback_cancel_answer: 'If you are trying to cancel an existing reservation, please refer to the cancellation policy that was provided in your confirmation email, as policy varies by restaurant and by reservation. (This information is also available in the Resy app and is stated with your reservation).',
  help_and_feedback_cancel_question: 'Trying to cancel an existing reservation?',
  help_and_feedback_heading: 'Help & Feedback',
  help_and_feedback_join: 'I own a restaurant and would like to join!',
  help_and_feedback_join_contact: 'Smart. We currently work with more than 9,000 restaurant partners and would love to have you, too.',
  help_and_feedback_more_information: 'More&nbsp;Information &rsaquo;',
  help_and_feedback_subheading: 'We’d love to hear from you.',
  hero_new_venues: 'new venues this month',
  hero_seats_booked: 'seats booked last 7 days',
  hero_subtitle: 'Resy powers some of the world\'s best restaurants, using technology to imagine the future of hospitality.',
  home_page: 'Home Page',
  host: 'Host',
  ical: 'Apple Calendar',
  in_partnership_with: 'In Partnership With',
  invite_add_to_calendar: 'Add to Calendar',
  invite_cancel: 'Cancel My Invite',
  invite_confirmed_header: 'All Set!',
  invite_confirmed_body: 'We assume that {host} is very much looking forward to seeing you.',
  invite_date_label: 'Date',
  invite_decline_confirm_body: 'Are you sure you want to leave the reservation?',
  invite_decline_confirm_header: 'Leave the reservation?',
  invite_decline_confirm_no: 'Cancel',
  invite_decline_confirm_yes: 'Leave',
  invite_declined_body: "Please <a href='mailto:help@resy.com'>email us</a> if you have questions.",
  invite_declined_header: 'Invite Declined',
  invite_declined_subtitle: "It's all good, we’ll let them down easy.",
  invite_download_link: "See Who's Going",
  invite_download_modal_body: "Let's get you on Resy, where you'll have full access to this reservation, including details, invite, and ResyPay.",
  invite_download_modal_header: 'Hey You.',
  invite_error_processing_line_1: 'There was a problem processing your request.',
  invite_error_processing_line_2: 'Please double check the link is correct.',
  invite_header: 'Join the reservation?',
  invite_not_found_body: "If so, the link you clicked was probably expired. Ask your friend to try again. Please <a href='mailto:help@resy.com'>email us</a> if you have any questions.",
  invite_not_found_header: 'Invite Not Found',
  invite_not_found_subtitle: 'Did you wait a while to RSVP? If so, the link may have expired. Ask your friend to send again.',
  invite_party_seats_label: 'Party of {seats}',
  invite_party_size_label: 'Party Size',
  invite_subtitle: '{host} invited you to {venue}. RSVP to join the party, get directions, set your dining preferences, and more.',
  invite_time_label: 'Time',
  invite_venue_label: 'Restaurant',
  keep_track: 'Keep track of the restaurants you love with your personal Hit List.',
  last_name: 'Last Name',
  learn_more: 'Learn More',
  learn_more_about_resyos: 'Learn more about ResyOS',
  less: 'Less',
  link_may_have_expired: 'The link may have expired. Please <a href=\"mailto:support@resy.com\">email us</a> if you have questions.',
  link_request_contact_field_placeholder: 'Email or mobile number',
  link_request_success: "Thanks. We'll send you a message with a link to download the Resy app.",
  list: 'List',
  list_venues_header: 'Check out all the great restaurants on Resy',
  local_scene: 'Local Scene',
  location_placeholder: 'Home ZIP, postal code, or city',
  location_search_placeholder: 'Search all locations...',
  location_search_placeholder_experiment: 'Search for a location',
  locations_header: 'Popular Cities',
  locked: 'Locked',
  login: 'Log in',
  login_message: "Resy's hospitality platform manages your account securely. Please sign up or log in to complete your reservation.",
  main_resy: 'Main Resy',
  maintenance_body_no_restore_time: 'As part of planned platform improvements, service is expected to be fully restored soon.',
  maintenance_body_with_restore_time: 'As part of planned platform improvements, service is expected to be fully restored by <strong>{restoreTime}</strong>.',
  maintenance_heading: 'Resy is currently undergoing scheduled maintenance.',
  make_default: 'Make Default',
  map: 'Map',
  map_redo: 'Search Here',
  marketing_accept: 'Get updates with curated recommendations, hit lists and more. By unchecking this box you will be opted out of marketing emails, however, you will still receive communications regarding your bookings for Resy restaurants, events, and experiences.',
  marketing_accept_gdpr: 'Receive news and curated dining recommendations from Resy including Hit Lists, neighbourhood + cuisine guides, and chef interviews via email. All emails include an unsubscribe link. You can opt out at any time.',
  marketing_opt_in: 'Receive marketing emails',
  marketing_opt_in_disclaimer: 'You agree to the use of your data as described in our <a href="/privacy" target="_blank">Privacy Policy</a>. You may opt out of receiving marketing emails at any time.',
  marketing_opt_in_error_state_title_text: 'Failed to Submit. Try Again',
  marketing_opt_in_error_state_detail_text: 'There was an error submitting this request.',
  marketing_opt_in_subhead: 'Sign up for Resy emails to receive curated recommendations and insider tips on top restaurants in your area.',
  marketing_opt_in_terms: 'By leaving this toggle off you will be opted out of marketing emails, however, you will still receive communications regarding your bookings for Resy restaurants, events, and experiences.',
  marketing_opt_in_title: 'Discover Restaurants to Love',
  menu: 'Menu',
  mobile_number: 'Mobile Number',
  mobile_number_success: 'Thanks, your phone number has been saved.',
  mobile_number_edit: 'Edit Mobile Number',
  mobile_number_desc: 'By providing your mobile number, you agree that it may be used to send you text messages and call you to confirm and manage your reservations.',
  mobile_number_new: 'Enter your new mobile number',
  mobile_number_verification_title: 'We sent you a code',
  mobile_number_verification_desc: 'We sent a 6-digit confirmation code to <span style=\"font-weight:bold; display:inline-block\">{phoneNumber}</span>. Enter it here to verify your new number.',
  mobile_number_note: 'By providing your mobile number, you agree that it may be used to send you text messages and call you to confirm and manage your reservations.',
  more: 'More',
  month: 'Month',
  months: {
    January: 'January',
    February: 'February',
    March: 'March',
    April: 'April',
    May: 'May',
    June: 'June',
    July: 'July',
    August: 'August',
    September: 'September',
    October: 'October',
    November: 'November',
    December: 'December',
  },
  next_month: 'Next month, {currentMonth} selected',
  prev_month: 'Previous month, {currentMonth} selected',
  more_collections: 'More collections',
  more_about_resy: 'More about Resy &rsaquo;',
  my_hit_list: 'My Hit List',
  multiple_list: 'Lists',
  nearby: 'Nearby',
  new: 'new on resy',
  new_desc: "Lucky for you, these restaurants are brand-New on Resy. We've sorted them by popularity because if you know, you know.",
  new_on_resy: 'New on Resy',
  new_password: 'New Password*',
  new_password_body: 'Please select a new password and then type it again. That way you won’t forget it (again).',
  new_to_resy: 'New to Resy?',
  newsroom: 'newsroom',
  next_favorite_restaurant: 'Your next favorite restaurant is a few taps away.',
  next_online_availability_message: 'At the moment, there&apos;s no online availability for {selectedDateFormatted}. The next availability for {selectedQuantity} is&nbsp;',
  no: 'No',
  no_availability_for_party_message: "Sorry, we don't currently have any tables available for {partySize}.",
  no_availability_message: "At the moment, there's no online availability for {selectedDate}.",
  no_events: 'There are no upcoming special events and experiences.',
  no_longer_receive_feedback: 'You’ll no longer receive feedback requests after your reservations.',
  no_inventory_modal_message: 'This venue doesn’t take reservations this far in advance. Come back closer to {selectedDate} to set a notify.',
  no_inventory_modal_title: 'Notify Unavailable',
  no_payment_methods: 'You have no payment methods on file.',
  no_reservations: 'You don’t have any past reservations.',
  no_thanks: 'No Thanks',
  no_upcoming_reservations: 'You don’t have any upcoming reservations.',
  not_found: 'Not Found.',
  notify_breakfast: 'Notify for Breakfast',
  notify_brunch: 'Notify for Brunch',
  notify_dinner: 'Notify for Dinner',
  notify_lunch: 'Notify for Lunch',
  notify_passed_group: 'From the team behind {notifyVenue}...',
  notify_passed_multiple_venues: 'You can set another Notify for {notifyVenue} and try again, or check out their sister restaurants.',
  notify_passed_one_venue: 'You can set another Notify for {notifyVenue} and try again, or check out their sister restaurant.',
  notify_passed_sorry: "Sorry it didn't work out",
  notify_remove_breakfast: 'Notify on for Breakfast, change or remove',
  notify_remove_brunch: 'Notify on for Brunch, change or remove',
  notify_remove_dinner: 'Notify on for Dinner, change or remove',
  notify_remove_lunch: 'Notify on for Lunch, change or remove',
  notify_table_no_longer_available: 'Unfortunately, you didn\'t get this one, but you\'ll be notified if another table opens up.',
  notify_table_no_longer_available_default: 'It\'s not you -- {venueName} is in high demand. We\'ll keep you on the Notify list if another table opens up.',
  notify_table_no_longer_available_title: 'Table no longer available',
  number_guests: '{number} Guests',
  number_tickets: '{seats} Tickets',
  ok: 'OK',
  onboarding: {
    challenge_copy: 'Please verify your account by entering the email address associated with the account:',
    challenge_title: 'Hey {firstName}, is that you? ',
    code_copy_one: 'We sent a 6-digit confirmation code to ',
    code_copy_two: '. It expires shortly, so enter it soon.',
    code_copy_no_password: 'No need for a password.',
    code_copy_email: 'We sent a 6-digit confirmation code to your email address',
    code_title: 'Check your mobile phone!',
    code_title_email: 'Check your email!',
    continue: 'Continue',
    create_account_cta: 'Create Account',
    create_account: 'Create account with email instead',
    create_account_with_phone: 'Create account with phone number instead',
    create_new_account: 'Create a new account',
    email_address: 'Email Address',
    enter_number: 'Please enter your mobile phone number to verify or create an account:',
    enter_number_for_sign_up: 'To create an account, please enter your mobile number:',
    footnote: '{venueName} and Resy will only use this number to confirm and manage your reservation.',
    footnote_secondary: 'By providing your mobile number, you agree to the Resy <a href=\"/terms\" target=\"_blank\">Terms of Use</a> and <a href=\"/privacy\" target=\"_blank\">Privacy Policy</a>, and your mobile number may be used to send you text messages and call you, through the use of an auto dialer, artificial, and/or prerecorded call or text, to service your Resy account including to confirm and manage reservations. Message and data rates may apply. Message frequency varies. You may opt out of receiving text messages at any time by replying STOP. Text HELP for help',
    help_title: 'How can we help?',
    need_help: 'Need Help?',
    no_account: 'Don’t have an account? ',
    not_first_name: 'Not {firstName}? ',
    password: 'Password',
    please_log_in: 'Please log in:',
    resend_code: 'Resend Code',
    request_email_code: 'Or, Log in with a one-time use code',
    sign_in: 'Log in with email & password',
    sign_in_email_code: 'Log in with email & one-time code',
    signup_copy: 'Let’s get some basic information so that {venueName} knows who you are.',
    signup_copy_secondary: 'Let’s get some basic information so that restaurants know who you are.',
    signup_title: 'Please create an account to continue.',
    title: '{venueName} uses Resy’s hospitality platform to securely manage your account information and reservations.',
    title_secondary: 'Resy’s hospitality platform securely manages your account information and reservations.',
    use_email: 'Use Email and Password instead',
    you_are_all_set: 'You are all set, {firstName}.',
    welcome_message: 'Welcome to Resy, {firstName}',
  },
  onboarding_benefit_terms: 'Benefit Terms &rsaquo;',
  onboarding_copy_member: "As an American Express Global Dining Access member you've unlocked access to additional reservations and will be first in line for Notify. Terms Apply.",
  onboarding_copy_prospect: 'Unlock access to exclusive reservations and special dining experiences when you add your eligible American Express<sup>®</sup> Card to your Resy profile. Terms Apply.',
  onboarding_exclusive_reservations_copy: 'Primetime tables are being held just for you. Look for the purple reservations within the Resy app or resy.com.',
  onboarding_exclusive_reservations_header: 'Exclusive Reservations',
  onboarding_explore: 'Explore Restaurants',
  onboarding_personal_concierge_member_account_page: 'Special booking access, just for you.',
  onboarding_personal_concierge_member: 'You have special access to reservations at this venue.',
  onboarding_personal_concierge_prospect: 'Enrolled members get exclusive access to tables at GDA venues.',
  onboarding_priority_access_copy: "Set a Notify and you'll receive a notification on tables at over 9,000 restaurants as soon as they open up, from the Resy app.",
  onboarding_priority_access_header: 'Priority Access to last-minute tables',
  onboarding_priority_notify_copy: 'Set a notify and be among the first to know when a hard-to-get table opens up.',
  onboarding_special_access_copy: 'Receive early access to in-person and virtual dining experiences with some of the best chefs and restaurants across the globe.',
  onboarding_special_access_header: 'Special Access to Events',
  onboarding_vip_status_title: 'A Badge on Your Resy Profile',
  onboarding_vip_status_copy: 'Restaurants will know that you are a valued member of the GDA program.',
  one_ticket: '1 Ticket',
  one_guest: '1 Guest',
  one_ticket_left: 'Sorry, we only have 1 ticket left.',
  online: 'Online',
  opted_out: 'Opted-Out.',
  optional: 'optional',
  other_times: 'other times',
  other_times_availability_message: 'At the moment, there&apos;s no online availability for {selectedDateFormatted} at {selectedTimeFormatted}, but there are&nbsp;',
  outlook: 'Outlook',
  partners_body: 'ResyOS offers cutting edge software, fair pricing and 24/7/365 customer service.',
  partners_price: 'Learn More &rsaquo;',
  partnership_inquiries: 'Partnership inquiries:',
  party_size: 'Party of {seats}',
  party_size_icon: 'Party size icon',
  password: 'Password',
  past_reservations: 'Past Reservations',
  payment_add_card_option: 'Add new card',
  payment_methods_title: 'Payment Methods',
  per_guest: 'per guest',
  per_ticket: 'per ticket',
  platinum_eyebrow: 'For Platinum Card<sup>&reg;</sup> Members',
  platinum_terms_aria_text: 'Opens in new window.',
  platinum_terms_link_text: 'Terms Apply',
  platinum_book_button_aria: 'Exclusive Night, Book {date}',
  powered_by_resy: "Powered by <span class='wordmark'>Resy</span>",
  prepaid_card_error: 'Sorry, we can\'t accept prepaid cards. Please try another payment method.',
  prepay_amount_description: 'It can be a fixed or maximum amount.',
  prepay_amount_error: 'Please add an amount.',
  prepay_amount_label: 'Subtotal (including tax)',
  prepay_amount_type_label_fixed: 'Fixed',
  prepay_amount_type_label_maximum: 'Max',
  prepay_card_description: '{type} ending in {last_4}',
  prepay_card_label: 'Card number',
  profile_card_edit_profile: 'Edit Profile',
  profile_card_notify_win: 'Notify Win',
  profile_card_notify_wins: 'Notify Wins',
  profile_card_joined_resy: 'Joined Resy',
  prepay_cardholder_name_label: 'Name on the card',
  prepay_charged_body: "You have been charged the amount below for your prepay. If you have any questions, please email <a href='mailto:support@resy.com?subject=3rd Party Pre-Pay'>support@resy.com</a>.",
  prepay_charged_header: 'Receipt',
  prepay_confirmed_body: "You will receive a receipt via SMS once your card has been charged. If you have any questions, please email <a href='mailto:support@resy.com?subject=3rd Party Pre-Pay'>support@resy.com</a>.",
  prepay_confirmed_header: 'Confirmed',
  prepay_edit_button: 'Edit',
  prepay_error_persists: 'If the error persists, please email <a href=\"mailto:support@resy.com?subject=3rd Party Pre-Pay\">support@resy.com</a>.',
  prepay_gratuity_description: 'This will be added to the amount.',
  prepay_gratuity_label: 'Add Gratuity?',
  prepay_gratuity_percentage_0: 'None',
  prepay_is_surprise_label: 'Is this a surprise?',
  prepay_item_description_error: 'Please add an item description.',
  prepay_item_description_label: 'Item description',
  prepay_item_description_placeholder: 'Bottle of wine, dessert...',
  prepay_legal: "Your credit card information is secure. By clicking \"Add Card\" you agree to Resy's <a href=\"/terms\" target=\"_blank\">Terms of Use</a> and <a href=\"/privacy\" target=\"_blank\">Privacy Policy</a>.",
  prepay_message_label: 'Optional Message',
  prepay_message_placeholder: 'E.g., who is this from?',
  prepay_payment_method_header: 'Confirm Payment',
  prepay_payment_method_submit: 'Confirm Purchase',
  prepay_reservation_name_label: 'Reservation name',
  prepay_select_payment_label: 'Select a payment method',
  prepay_start_header: 'Secure Payment',
  prepay_start_instructions: 'Please complete the secure form below to complete your transaction at {venueName}. If you have any questions, please email <a href=\"mailto:support@resy.com?subject=3rd Party Pre-Pay\">support@resy.com</a>.',
  prepay_submit_button: 'Continue to Payment',
  prepay_summary: 'Pre-Pay Summary',
  prepay_timing_end_of_meal: 'End of meal',
  prepay_timing_label: 'When should the guest(s) be informed?',
  prepay_timing_null: 'Select timing...',
  prepay_timing_other: 'Other',
  prepay_timing_other_message_error: "Please, tell us when you'd like the guest to be informed.",
  prepay_timing_other_message_placeholder: 'Tell us when...',
  prepay_timing_when_delivered: 'When delivered',
  prepay_timing_when_seated: 'When seated',
  preview: 'Preview',
  priority_notify: 'Priority Notify',
  privacy_policy: 'Global Privacy Policy',
  profile: 'Profile',
  profile_menu: 'Profile menu',
  profile_photo_change: 'Change',
  profile_photo_change_aria_label: 'Change Profile Picture',
  profile_subtitle: 'We only share this information with restaurants you reserve, so they can coordinate with you and know your preferences.',
  profile_success: 'Thanks, your profile has been saved.',
  profile_success_email: "Thanks, a confirmation email was sent to {email}.<br/><span style='font-weight:normal'>Your email will not be changed until you confirm.</span>",
  reason_for_requesting_input: 'Reason for requesting...',
  reason_for_requesting_input_label: 'Reason for Requesting',
  recommendations: 'Recommended for You',
  remove: 'Remove',
  remove_all: 'Remove All',
  remove_card_error_title: 'Unable to Remove Card',
  remove_card_number_announcement: 'Remove {type} credit card number ending in {lastFour}',
  remove_card_reservation_error_subtitle: 'This card is required for a future reservation.',
  remove_notify_error: 'Could Not Remove Notify',
  remove_notify_for_date: 'Remove other Notify alerts for<br />{date}?',
  remove_notify_subtitle: 'Looks like you have other alerts set on the same day. Do you want to remove those and give others a chance?',
  remove_stored_card_question: 'Remove Stored Card?',
  reservation_date: 'Reservation Date',
  reservation: 'Reservation',
  reservations: 'Reservations',
  reservations_and_notify: 'Reservations &amp; Notify',
  reset_password_body: 'You know the drill. Please start by providing the email address you used to register.',
  reset_password_header: 'Reset password',
  reset_password_success: "If a Resy account has been set up using this email address, you'll receive an email shortly.",
  resy_blog: 'Resy Blog',
  resy_blog_content: 'Resy blog content',
  resy_by_the_numbers: 'Resy By The Numbers',
  resy_by_the_numbers_label_1: 'diners seated',
  resy_by_the_numbers_label_2: 'no show rate',
  resy_by_the_numbers_label_3: 'restaurants',
  resy_by_the_numbers_label_4: 'cities',
  resy_facebook: 'Resy Facebook',
  resy_instagram: 'Resy Instagram',
  resy_twitter: 'Resy Twitter',
  resy_logo: 'Resy logo',
  resy_logo_right_this_way: 'Resy logo, right this way',
  resy_logo_click_home: 'Resy Logo. Click to go home.',
  resy_partners: 'Resy Partners',
  resy_select_restaurant: 'Resy Select Restaurant',
  resy_spotlight: 'Resy Spotlight',
  resypay_link: 'Pay with ResyPay',
  resy_credit: 'The Resy Credit',
  resy_credit_banner_tagline_eligible_temp_copy: 'Purchases made directly at this venue currently qualify for the Resy Credit, a benefit for select American Express® Card Members.',
  review_label: '(1) review',
  reviews_label: '({localizedResult}) reviews',
  rga: 'Global Dining Access',
  same_group_recommendations_eyebrow: 'From the {name} team',
  safety_measures: 'Safety Measures',
  save: 'Save',
  save_card: 'Save Card',
  saving_wait: 'Saving. Please wait...',
  search: 'Search',
  search_aria_label: 'There are {num} results from your query. Use the up and down arrows to navigate results. {updateStr}',
  search_book_a_restaurant: 'Book a Restaurant',
  search_collections_header: 'Resy Collections',
  search_metadata_collection: 'Collections',
  search_metadata_cuisine: 'Cuisine',
  search_metadata_neighborhood: 'Neighborhood',
  search_metadata_query: "Results Matching '{query}', {date}, {seats} Guests, in {city}",
  search_filter_resy_credit: 'Resy Credit',
  search_headline_resy_credit: 'Resy Credit eligible restaurants in {city}',
  search_resy_credit_description: 'These venues currently qualify for the Resy Credit, a benefit for select American Express® Card Members.',
  search_resy_credit_terms: 'Terms apply.',
  search_no_results_query_body: 'Try another search, adjust party size and date, or zoom out.',
  search_no_results_default: 'No tables available.',
  search_no_results_query_header: 'No results for &ldquo;{query}&rdquo;.',
  search_restaurant_placeholder: 'Search restaurants, cuisines, etc.',
  search_view_all: 'View all {city} Restaurants',
  venue_type_search_pill_restaurants: 'Restaurants',
  venue_type_search_pill_wineries: 'Wineries',
  venue_type_search_pill_all_venues: 'All Venues',
  see_all: 'See all',
  see_all_collection: 'See all {title}',
  see_all_card: 'See all venues in this collection',
  see_all_label: 'See All &rsaquo;',
  see_all_results_for_query: 'See all results for &quot;{searchString}&quot;&nbsp;&rsaquo;',
  see_more: 'see more &rsaquo;',
  see_more_collection: 'see more {collection}',
  see_more_label: 'see more',
  see_more_venues_in_collection: 'See more venues in the {title} collection',
  select_city: 'Select a City',
  set_a_notify_message: 'Set a notify so you don’t miss out.',
  set_card_as_default: 'Set card as default payment method',
  set_password_success: 'Success. Your new password has been set.',
  settings_saved: 'Thanks, your settings have been saved.',
  share: 'Share',
  short_bio: 'Short Bio',
  show_all: 'Show all',
  signout: 'Sign Out',
  signup: 'Sign up',
  skip_to_main: 'Skip to Main',
  social_media: 'Social media',
  sold_out: 'Sold Out',
  some_tickets_left: 'Sorry, we only have {n} tickets left.',
  special_events: 'Special Events &amp; Experiences',
  table_config_id_not_found: "We're sorry, the table you were looking for is no longer available. Please see below for our current availability.",
  take_a_look: 'Take a look',
  tax: ' + tax',
  tax_gratuity: ' + tax and fees',
  terms_accept: "I have read and accept the <a href='/privacy' tabindex='0' target='_blank'>Privacy Policy</a> and <a href='/terms' tabindex='0' target='_blank'>Terms of Service</a>",
  terms_of_service: 'Terms of Service',
  terms_of_service_resypay: 'Resy Pay Terms and Conditions',
  this_cannot_be_undone: 'This cannot be undone.',
  ticket: 'Ticket',
  tickets: 'Tickets',
  timeslot_not_found: "Sorry we don't have any tables available {date} at {time}. Please see below for our current availability.",
  titles: {
    about: 'About Resy',
    accessibility: 'Accessibility Statement',
    all_restaurants: 'All Restaurants',
    amex_offer: 'Dine Out and Earn Rewards with Amex',
    amex_gda: 'Global Dining Access by Resy',
    amex_gda_dir: 'Global Dining Access by Resy - Program Restaurant Directory',
    amex_nps_terms: 'Restaurant Satisfaction Survey Q4 2022 Sweepstakes',
    amex_nps_terms_q2_2023: 'Restaurant Satisfaction Survey Q2 2023 Sweepstakes',
    blend_error: 'Blend - Error',
    careers: 'Work at Resy',
    communication_title: 'Communication',
    confirmation_received: 'Confirmation Received',
    cookie: 'Cookie Policy',
    default: 'Resy | Right This Way',
    download: 'Download',
    dpa: 'Data Processing Addendum',
    email_verified: 'Thanks For Verifying Your Email',
    error: 'Page Not Found',
    events: 'Special Dining Events and Experiences on Resy',
    help_and_feedback_title: 'Help and Feedback',
    home: 'Resy | Your Guide to the World\'s Best Restaurants',
    invite: {
      confirmed: 'Invite Confirmed',
      declined: 'Invite Declined',
      not_found: 'Invite Not Found',
      pending: 'Invite Pending',
      rsvpForVenue: 'RSVP for',
    },
    link: 'Link',
    my_hit_list: 'My Hit List',
    multiple_list: 'Lists',
    new_table_added: 'New Table Added',
    password_criteria_met: 'Met',
    password_criteria_not_met: 'Not Met',
    password_length: 'At least (8) characters',
    password_letter: 'At least (1) letter',
    password_number: 'At least (1) number',
    password_reset_copy: 'You know the drill. Please start by providing the email address you used to register.',
    password_set_copy: 'Please set a new password and then type it again. That way you won’t forget it (again).',
    password_special_char: 'At least (1) symbol (!?$^& etc.)',
    payment_methods_title: 'Payment Methods',
    prepay: 'Prepay',
    prepay_confirmation: 'Prepay Confirmed',
    prepay_payment_method: 'Prepay Payment Method',
    privacy: 'Global Privacy Policy',
    profile: 'Your Resy Profile',
    rate: 'Rate Your Experience',
    rate_venue: 'Rate Your Experience at {venueName}',
    rating_label: '{score} out of {scale} stars',
    reservations_and_notify: 'Reservations & Notify',
    reset_password: 'Reset Password',
    restaurant_reservations: 'Restaurant Reservations',
    restaurants_in: 'Restaurants in {locationName}',
    search_market: 'Discover {locationName} Restaurants to Love on Resy',
    search_restaurants: 'Search Restaurants',
    set_password: 'Set Password',
    skip_to_main: 'Skip to Main',
    terms: 'Terms of Service',
    venue_details: 'Book Your {venueName} Reservation Now on Resy',
    venue_details_description: 'Book {venueName} in {marketCity} on Resy',
    event_details: 'Book Your {eventName} Event With {venueName} on Resy',
    amex_shop_small: 'Amex & Shop Small® Present: The Resy Tastemakers',
    amex_experiences: 'Special Resy Events and Experiences',
    amex_gda_b2b: 'Global Dining Access for Restaurants',
    resy_security_center: 'Resy Security Center',
    resy_credit: 'Resy Credit',
    resy_value: 'Welcome to Resy',
    platinum_nights: 'Platinum Nights by Resy',
  },
  descriptions: {
    default: 'Discover restaurants to love in your city and beyond. Get the latest restaurant intel and explore Resy’s curated guides to find the right spot for any occasion. Book your table now through the Resy iOS or Android app, or on Resy.com.',
    about: 'Resy takes your passion for restaurants to the next level. From hard-to-get reservations to unique dining events, the most exciting experiences in your city – and beyond – are just a few taps away.',
    amex_offer: 'The restaurants you love. The rewards you crave. Earn rewards when you dine out with the American Express® Platinum Card, the Gold Card, or the Blue Cash Everyday Card.',
    amex_gda: 'A personal dining concierge, at your fingertips. Global Dining Access by Resy gives you special access to sought-after restaurants across the country when you add your American Express® Platinum Card to your Resy profile. Unlock exclusive reservations, premium dining experiences, Priority Notify, and more, all from Resy.com and the Resy iOS app.',
    amex_gda_dir: 'Discover and book exclusive reservations and dining events at these top restaurants. ',
    events: 'From drive-thru tasting menus to pizza giveaways, there are even more ways to experience the restaurants you love — both in-person and virtually. Book special restaurant events and experiences right on Resy.',
    profile: 'Start dining with Resy now. Book and change reservations, add restaurants to your personal Hit List, and securely manage your account information.',
    search_market: 'Looking for the best bars, brunch spots, and everything in between? Search our curated collections for {locationName} restaurants and book them right on Resy.',
    accessibility: 'Resy is committed to providing a valuable and more accessible digital experience for all visitors, including people with disabilities.',
    amex_shop_small: 'Resy is telling the stories behind the restaurants that influence how we dine today.',
    amex_experiences: 'Discover a curated collection of Resy events and dining experiences',
    amex_gda_b2b: 'Global Dining Access pairs the world\'s best restaurants with the best guests by unlocking exclusive reservations to some of the most sought-after restaurants through Resy.',
    resy_security_center: 'Tips and best practices to keep your Resy account secure',
    resy_credit: 'The Resy Credit is a benefit offered to eligible American Express Card Members who can earn statement credits after paying with an enrolled Card to dine at U.S. Resy restaurants or make other eligible Resy purchases. Terms Apply.',
    resy_value: 'Resy gives you access to top restaurants. From insider recommendations to special dining experiences, learn how Resy is more than reservations.',
    platinum_nights: 'With Platinum Nights by Resy, you can get special access to reservations on select nights at participating in demand US Resy restaurants in select cities with your Platinum Card(R). Simply add your eligible Card to your Resy profile to discover and book Platinum Nights Reservations. Terms Apply.',
  },
  top_rated: 'top rated',
  top_rated_desc: "A crowd-sourced stamp of approval. The five-star treatment. Resy's top-rated restaurants according to you, the guests.",
  toprated: 'top rated',
  upcoming_concierge_reservations: 'Upcoming Concierge Reservations',
  upcoming_events_at_venue: 'Upcoming Events at {venueName}',
  upcoming_events_slider_event_progress_title: '{eventName}, {date} {time}, item {slideNumber} of {totalSliderItems}',
  upcoming_reservations: 'Upcoming Reservations',
  upcoming_reservations_show_all: 'Show More Upcoming',
  venue_about_header: 'About {venueName}',
  venue_added_to_favorites: '{venueName} added to favorites',
  venue_credit_card_requirement: 'This venue requires a credit card to book because this reservation is either pre-paid, has pre-paid items, or may have a cancellation fee.',
  venue_cuisine_header: 'Cuisine type',
  venue_description_read_more: 'Read more',
  venue_description_read_less: 'Read less',
  venue_need_to_know_header: 'Need to Know',
  venue_page_gda_tooltip: 'This venue sets aside tables for Global Dining Access members. Click to learn more.',
  venue_page_gda_tooltip_member: 'As a Global Dining Access member, you get exclusive access to tables at this venue.',
  venue_rating_header: 'Rating',
  venue_removed_from_favorites: '{venueName} removed from favorites',
  venue_safety_description: '{venueName} has provided resources to learn even more about what they\'re doing to ensure a safe and comfortable dining experience.',
  venue_support: 'Other ways to support {venueName}:',
  venue_why_we_like_it_header: 'Why We Like It',
  view_all_open_positions: 'View All Open Positions',
  view_all_safety_measures: 'View all safety measures',
  view_communication_preferences: 'View Communication Preferences ›',
  view_link: 'Click to view',
  view_menu: 'View Menu',
  view_num_safety_measures: 'View all {totalSafetyMeasures} safety measures',
  virtual: 'Virtual',
  work_at_resy: 'Work at Resy',
  year: 'Year',
  yes: 'Yes',
  you_might_also_like: 'You Might Also Like...',
  your_city_is_empty: 'Your {city} Hit List is empty.',
  your_rating: 'Your Rating',
  reservation_modify_menu: 'Reservation Modify Menu',
  notify_modify_menu: 'Notify Modify Menu',
  warning_leaving_resy: 'You are about to leave Resy\'s website.',
  welcome_amex_intro_access_description1: 'Get instant access to some of the best restaurants on <a href=\"/\" target=\"_blank\">resy.com</a> or the Resy iOS app.',
  welcome_amex_intro_access_description2: 'Don\'t have a Resy Account? ',
  welcome_amex_intro_access_description3: 'Create your account.',
  welcome_amex_intro_access_link: 'Download the iOS App Now',
  welcome_amex_intro_header: 'Get More When You Dine with Resy and American Express',
  welcome_amex_intro_second_header: 'Add your eligible American Express Card to your Resy wallet to start enjoying exclusive benefits. All it takes is three easy steps:',
  welcome_amex_intro_description1: 'If you have a Platinum Card or <a href=\"/global-dining-access#global-dining-access-terms\" target=\"_blank\">other eligible Card</a>, you can enjoy Global Dining Access by Resy, which gives eligible American Express Card Members access to exclusive reservations, Priority Notify at any Resy restaurant, and invitations to special dining experiences. Terms apply.',
  welcome_amex_intro_description1_link: 'Learn More',
  welcome_amex_intro_subheader: 'Add your Card to your Resy Wallet:',
  welcome_amex_intro_description2: 'Put your Card on file, and these exclusive benefits are yours to enjoy.',
  welcome_amex_unlock_card1: 'Log in to your Resy profile.',
  welcome_amex_unlock_card2: 'Within your profile, click <strong>\"Payment Methods\"</strong>.',
  welcome_amex_unlock_card3: 'Click <strong>&quot;Add Credit Card&quot;</strong> to add your eligible American&nbsp;Express<sup>&reg;</sup> Card to your Resy profile.',
  welcome_amex_unlock_add_button: 'Add Your Card',
  welcome_amex_terms_apply_link: 'Terms and Conditions',
  welcome_gold_section_header: 'Enjoy 4X Points at Restaurants',
  welcome_gold_section_description: 'American Express Gold Card Members earn 4X points at restaurants worldwide. Plus, unlock exclusive access to Resy event pre-sales and special experiences when you add your Gold Card to your Resy profile.',
  welcome_gold_section_description_link: 'Terms Apply',
  welcome_download_app_description: 'Receive push notifications when the table you want becomes available, and book on the go.',
  welcome_download_app_description_link: 'Download the iOS App Now',
  welcome_features_intro_header: 'How to get the most out of Resy',
  welcome_features_card_header1: 'Set a Notify',
  welcome_features_card_header2: 'Create a Personal&nbsp;Hit&nbsp;List',
  welcome_features_card_header3: 'See What&apos;s Climbing',
  welcome_features_card_header4: 'Invite a Guest',
  welcome_features_card_description1: 'If the reservation you want isn&apos;t available, Resy&apos;s signature Notify feature alerts you if a table opens up.',
  welcome_features_card_description2: 'Build a customized list of your essential eateries, and easily access it for faster bookings.',
  welcome_features_card_description3: 'Climbing on Resy is the only data-driven list powered by diners&apos; reservations. Consider it a live, curated guide by locals, for locals.',
  welcome_features_card_description4: 'Share reservation details with your party so everyone has the details in one place.',
  welcome_highlights_intro_header: 'Ready to become a&nbsp;regular?',
  welcome_highlights_intro_description: 'When you’re with Amex and Resy, we take your passion for restaurants to the next level. From hard-to-get reservations to unique dining events, exciting experiences in your city – and beyond – are just a few taps away.',
  welcome_highlights_learn_header1: 'An Insider&apos;s Lens',
  welcome_highlights_learn_header2: 'Exclusive Events',
  welcome_highlights_learn_header3: 'Reservations at Sought-After Restaurants',
  welcome_highlights_learn_description1: 'As soon as we know, you know. We provide coverage in major markets to get you the intel on some of your city\'s most exciting restaurants, and our curated guides can help you discover your new favorite spot.',
  welcome_highlights_learn_description2: 'From drive-thru tasting menus to pizza giveaways to digital wine consultations, there are even more ways to experience the restaurants you love — both in-person and virtually. Plus, if you add your eligible American Express<sup>&reg;</sup> Card to your Resy profile, you can unlock access to event pre-sales, special dining experiences, and more.',
  welcome_highlights_learn_description3: 'Resy powers some of the world\'s best restaurants. For you, that means seamless reservations through the Resy iOS app or on <a href="/" target="_blank">resy.com</a>. More good news: If you have an American Express<sup>®</sup> Platinum Card or <a href="/global-dining-access#global-dining-access-terms" target="_blank">other eligible Card</a>, you can add it to your Resy profile to unlock access to exclusive reservations with <a href="/global-dining-access" target="_blank">Global Dining Access by Resy</a>.',
  welcome_highlights_learn_description4: 'Terms apply. To see the full terms and learn which Cards are eligible, ',
  welcome_highlights_learn_description5: 'click here.',
  welcome_highlights_learn_description6: 'Terms apply to individual event bookings.',
  welcome_highlights_learn_cta1: 'Read More',
  welcome_highlights_learn_cta2: 'See More',
  welcome_highlights_learn_cta3: 'Discover Restaurants to Love',
  please_try_adding_another_payment_method: 'Please try adding another payment method',
  this_card_could_not_be_added: 'This card could not be added',
  gda_by_resy_logo: 'Global Dining Access by Resy logo',
  gda_priority_notify_icon: 'Priority notify icon',
  gda_exclusive_offer_icon: 'Exclusive reservations icon',
  gda_special_experience_icon: 'Special experiences icon',
  gda_priority_notify_banner_text: 'Be one of the first in line with Priority Notify',
  remind_me_later_success_text: 'We\'ll remind you about this next time',
  success_icon: 'Success icon',
  protip_icon: 'Pro tip icon',
  protip_text: 'Pro tip: add your eligible American Express&reg; Card to earn dining rewards and make the most of Resy. Terms Apply.',
  announcement_logo: 'Announcement logo',
  announcement_icon: 'Announcement icon',
  verify_phone_aria_text: 'Verify phone number using one time code',
  help_aria_text: 'Help',
  verify_email_aria_text: 'Verify account by entering email address',
  login_aria_text: 'Login using email and password',
  phone_aria_text: 'Enter phone number',
  signup_aria_text: 'Sign up',
  email_code_aria_text: 'Verify email address using one time code',
  email_aria_text: 'Enter email address',
  success_view_aria_text: 'Login success',
  celebration_aria_text: 'Sign up success celebration',
};

export default translationMap;
